import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';

export class HotjarConfig {
  siteId = '';
}

@NgModule({
  imports: [CommonModule],
})
export class HotjarModule {
  constructor(
    @Optional() @SkipSelf() parentModule: HotjarModule,
    config: HotjarConfig
  ) {
    // Check if NgModule was previously loaded
    // https://angular.io/guide/ngmodule-faq#how-can-i-tell-if-an-ngmodule-or-service-was-previously-loaded
    if (parentModule) {
      throw new Error(
        'HotjarModule is already loaded. Import it in the AppModule only'
      );
    }

    if (!config) {
      throw new Error(
        'Provide config for HotjarModule using the forRoot method'
      );
    }

    if (location.protocol === 'https:' && config.siteId) {
      // * Hotjar Tracking Code
      // https://help.hotjar.com/hc/en-us/articles/115011639927-What-is-the-Hotjar-Tracking-Code-
      (function (h: any, o, t, j, a, r) {
        h.hj =
          h.hj ||
          function () {
            (h.hj.q = h.hj.q || []).push(arguments); /* eslint-disable-line prefer-rest-params */
          };
        h._hjSettings = { hjid: config.siteId, hjsv: 6 };
        a = o.getElementsByTagName('head')[0] as any;
        r = o.createElement('script') as any;
        (<any>r).async = 1;
        (<any>r).src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        (<any>a).appendChild(r);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }
  }

  static forRoot(config: HotjarConfig): ModuleWithProviders<HotjarModule> {
    return {
      ngModule: HotjarModule,
      providers: [
        {
          provide: HotjarConfig,
          useValue: config,
        },
      ],
    };
  }
}
